module.exports = __webpack_public_path__ + "static/Logo_Textron_black-a400a028bcbbb7f72a7e1f9c8210dea3.png";